var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9998 11.0006H4.41379L9.70679 5.70757C9.8023 5.61532 9.87848 5.50498 9.93089 5.38297C9.9833 5.26097 10.0109 5.12975 10.012 4.99697C10.0132 4.86419 9.98789 4.73251 9.93761 4.60962C9.88733 4.48672 9.81307 4.37507 9.71918 4.28117C9.62529 4.18728 9.51364 4.11303 9.39074 4.06275C9.26784 4.01247 9.13616 3.98717 9.00339 3.98832C8.87061 3.98947 8.73939 4.01706 8.61738 4.06947C8.49538 4.12188 8.38503 4.19806 8.29279 4.29357L1.29279 11.2936C1.10532 11.4811 1 11.7354 1 12.0006C1 12.2657 1.10532 12.52 1.29279 12.7076L8.29279 19.7076C8.48139 19.8897 8.73399 19.9905 8.99619 19.9882C9.25838 19.986 9.5092 19.8808 9.6946 19.6954C9.88001 19.51 9.98518 19.2592 9.98746 18.997C9.98974 18.7348 9.88894 18.4822 9.70679 18.2936L4.41379 13.0006H21.9998C22.265 13.0006 22.5194 12.8952 22.7069 12.7077C22.8944 12.5201 22.9998 12.2658 22.9998 12.0006C22.9998 11.7354 22.8944 11.481 22.7069 11.2935C22.5194 11.1059 22.265 11.0006 21.9998 11.0006Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.8e60be218a81457cbea1f93da28d0998.svg";
export { ForwardRef as ReactComponent };